import React from 'react';
import OtovoIcon from '../../../../assets/icons/OtovoIcon';
import OtovoIconActive from '../../../../assets/icons/OtovoIconActive';
import OtovoComponent from './Components/Companies/OtovoComponent';
import { enableOtovo } from '../../../../config';

export const defaultExperimentBlock = {
  menuItem: {
    title: '',
    icon: null,
    activeIcon: null,
    isEnable: true,
    hideInPrivateProperty: false,
    hideOnLands: false,
    hideOnGarageBuilding: false,
    isNew: false,
  },
  title: '',
  experimentSlug: '',
  description: [],
  descriptionList: [],
  commonExperimentComponent: <></>,
  moreDescriptionTopic: '',
  moreDescription: [''],
  moreDescriptionQuestions: [],
  commonExperimentComponentTitle: '',
  secondCommonExperimentComponent: '',
  learnMoreLink: {
    link: null,
    text: null,
    location: null,
  },
};

export const otovoIframeUrl =
  'https://solar.otovo.com/nb-no/search?context=iframe&utm_source=boligmappa&theme=default';
export const experimentTemplateData = [
  {
    menuItem: {
      title: 'Solcellepanel',
      icon: OtovoIcon,
      activeIcon: OtovoIconActive,
      isEnable: enableOtovo === 'true',
      hideInPrivateProperty: false,
      hideOnLands: false,
      hideOnGarageBuilding: false,
      isNew: true,
    },
    title: 'Spar penger på taket ditt',
    experimentSlug: 'otovo',
    description: [
      'Boligmappa samarbeider med Otovo, som er et av landets ledende aktører på solceller. Hos Otovo kan du lease ditt solcelleanlegg med markedets beste garantier',
      'Solenergi har aldri vært lettere å utnytte. I løpet av få sekunder viser vi deg hvor mye strøm du kan produsere. Ved bruk av solstrøm over tid kan solcellene ende opp med å produsere gratis strøm i flere år.',
      'Det er mange faktorer som påvirker hva et solcelleanlegg vil koste deg. Faktorene som blant annet påvirker prisen er:',
    ],
    descriptionList: [
      'ønsker du å kjøpe eller lease solcellene?',
      'installasjonskompleksitet',
      'antall takflater',
      'type taktekking',
      'valg av inverter og optimizer',
    ],
    commonExperimentComponent: (
      <OtovoComponent
        description="Økende strømpriser gjør solstrøm til et mer lønnsomt alternativ.  Nå kan vi beregne den årlige besparelsen du gjør ved å kjøpe solceller."
        title="Se hva du kan spare på din adresse"
        url="https://solar.otovo.com/nb-no/search?context=iframe&utm_source=boligmappa&theme=default"
        bannerImageUrl="https://ik.imagekit.io/boligmappa/Experiments/enovo.png?ik-sdk-version=javascript-1.4.3&updatedAt=1667386286269"
      />
    ),
    moreDescriptionTopic: 'Spar penger på taket ditt',
    moreDescription: [],
    moreDescriptionQuestions: [],
    commonExperimentComponentTitle: '',
    secondCommonExperimentComponent: '',
    learnMoreLink: {
      link: null,
      text: null,
      location: null,
    },
  },
];
